<template>
  <form id="create_banner_form">
    <div class="card card-custom gutter-b">
      <div class="card-body">
        <div>
          <form>
            <label>برنامه‌ با حداکثر ۳ مقصد (هر دقیقه)</label>
            <div class="row">
              <div class="col-sm-6">
                <b-form-select
                  :options="labels"
                  class="form-control mb-3"
                  value-field="id"
                  text-field="title"
                  v-model="form.selected_live_base"
                  @change="onChangelivebase"
                >
                  <template #first>
                    <b-form-select-option value="all">
                      همه
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </div>
              <div class="col-sm-6">
                <input
                  class="form-control form-control-lg form-control-solid"
                  type="number"
                  dir="ltr"
                  v-model="form.live_base[form.selected_live_base]"
                />
              </div>
            </div>
            <label>مقصد اضافه (هر دقیقه)</label>
            <div class="row">
              <div class="col-sm-6">
                <b-form-select
                  :options="labels"
                  class="form-control mb-3"
                  value-field="id"
                  text-field="title"
                  v-model="form.selected_live_destination"
                  @change="onChangedestination"
                >
                  <template #first>
                    <b-form-select-option value="all">
                      همه
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </div>
              <div class="col-sm-6">
                <input
                  class="form-control form-control-lg form-control-solid"
                  type="number"
                  dir="ltr"
                  v-model="
                    form.live_destination[form.selected_live_destination]
                  "
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div
      v-if="
        appPrices && appPrices['live_base'] && appPrices['live_destination']
      "
      class="card card-custom gutter-b"
    >
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">قیمت فعلی</h3>
        </div>
      </div>
      <div class="card-body">
        <BasicCalculation :prices="appPrices"></BasicCalculation>
      </div>
    </div>
  </form>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";
import {
  FETCH_APP_PRICES,
  STORE_APP_PRICES
} from "@/core/services/store/prices.module";
import BasicCalculation from "../../BasicCalculation.vue";

export default {
  name: "admin-prices",
  components: { BasicCalculation },
  data() {
    return {
      form: {
        selected_live_base: "all",
        selected_live_destination: "all",
        live_base: new Array(24).fill(0),
        live_destination: new Array(24).fill(0)
      },
      labels: [
        { id: "0", title: "00:00 - 01:00" },
        { id: "1", title: "01:00 - 02:00" },
        { id: "2", title: "02:00 - 03:00" },
        { id: "3", title: "03:00 - 04:00" },
        { id: "4", title: "04:00 - 05:00" },
        { id: "5", title: "05:00 - 06:00" },
        { id: "6", title: "06:00 - 07:00" },
        { id: "7", title: "07:00 - 08:00" },
        { id: "8", title: "08:00 - 09:00" },
        { id: "9", title: "09:00 - 10:00" },
        { id: "10", title: "10:00 - 11:00" },
        { id: "11", title: "11:00 - 12:00" },
        { id: "12", title: "12:00 - 13:00" },
        { id: "13", title: "13:00 - 14:00" },
        { id: "14", title: "14:00 - 15:00" },
        { id: "15", title: "15:00 - 16:00" },
        { id: "16", title: "16:00 - 17:00" },
        { id: "17", title: "17:00 - 18:00" },
        { id: "18", title: "18:00 - 19:00" },
        { id: "19", title: "19:00 - 20:00" },
        { id: "20", title: "20:00 - 21:00" },
        { id: "21", title: "21:00 - 22:00" },
        { id: "22", title: "22:00 - 23:00" },
        { id: "23", title: "23:00 - 00:00" }
      ]
    };
  },
  mounted() {
    this.setBreadcrumbs();
    this.setActions();
    this.getAppPrices();

    this.eventHub.$on("save-prices-event", this.save);

    this.fv = formValidation(document.getElementById("create_banner_form"), {
      fields: {},
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  beforeDestroy() {
    this.eventHub.$off("save-prices-event");
    document.getElementById("save-prices-btn").disabled = false;
  },
  computed: {
    ...mapGetters(["appPrices"]),
    companiesList() {
      return JSON.parse(JSON.stringify(this.adminCompanies));
    }
  },
  methods: {
    onChangelivebase(event) {
      this.form.selected_live_base = event;
    },
    onChangedestination(event) {
      this.form.selected_live_destination = event;
    },
    getAppPrices() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_APP_PRICES)
        .then(() => {
          this.loaded = true;
          this.form.live_base = this.appPrices.live_base
            .concat(new Array(24).fill(0))
            .slice(0, 24);
          this.form.live_destination = this.appPrices.live_destination
            .concat(new Array(24).fill(0))
            .slice(0, 24);
          this.form.live_base["all"] = this.form.live_base[0];
          this.form.live_destination["all"] = this.form.live_destination[0];
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    setBreadcrumbs() {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: "مدیریت",
          route: { name: "admin-dashboard" }
        },
        { title: "قیمت گذاری" }
      ]);
    },
    setActions() {
      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "ذخیره",
            event: "save-prices-event",
            class: "btn-primary",
            id: "save-prices-btn"
          }
        ]
      });
    },
    save() {
      if (this.form.selected_live_base === "all") {
        for (let i = 0; i < 24; i++) {
          this.form.live_base[i] = this.form.live_base[
            this.form.selected_live_base
          ];
        }
      }
      if (this.form.selected_live_destination === "all") {
        for (let i = 0; i < 24; i++) {
          this.form.live_destination[i] = this.form.live_destination[
            this.form.selected_live_destination
          ];
        }
      }
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("save-prices-btn");
          this.disableBtn(submitBtn);

          this.$store
            .dispatch(STORE_APP_PRICES, this.form)
            .then(() => {
              this.enableBtn(submitBtn);
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    }
  }
};
</script>
